export const DASHBOARD_PANEL_CREATE_EDIT_OPEN_MODAL = "DASHBOARD_PANEL_CREATE_EDIT_OPEN_MODAL";
export const DASHBOARD_PANEL_CREATE_REQUEST = "DASHBOARD_PANEL_CREATE_REQUEST";
export const DASHBOARD_PANEL_CREATE_RESULT = "DASHBOARD_PANEL_CREATE_RESULT";
export const DASHBOARD_PANEL_EDIT_REQUEST = "DASHBOARD_PANEL_EDIT_REQUEST";
export const DASHBOARD_PANEL_EDIT_RESULT = "DASHBOARD_PANEL_EDIT_RESULT";
export const DASHBOARD_PANEL_SEARCH_REQUEST = "DASHBOARD_PANEL_SEARCH_REQUEST";
export const DASHBOARD_PANEL_SEARCH_RESULT = "DASHBOARD_PANEL_SEARCH_RESULT";